function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20029051_90756)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.57153 3.33333C12.2475 3.33333 15.2382 6.324 15.2382 10C15.2382 13.676 12.2475 16.6667 8.57153 16.6667C4.89553 16.6667 1.90487 13.676 1.90487 10C1.90487 6.324 4.89553 3.33333 8.57153 3.33333ZM8.57153 2C4.15353 2 0.571533 5.582 0.571533 10C0.571533 14.418 4.15353 18 8.57153 18C12.9895 18 16.5715 14.418 16.5715 10C16.5715 5.582 12.9895 2 8.57153 2ZM9.2382 10V6H7.90487V11.3333H12.5715V10H9.2382Z",
  fill: "#C4C4C4"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20029051_90756"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.571533 2)"
})));

function SvgStatusSettling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSettling);
export default __webpack_public_path__ + "static/media/statusSettling.62d522ccc93b36e13f726789a1b53493.svg";
export { ForwardRef as ReactComponent };